export default function PaginationControl({ page, totalPages, totalData, onPrev, onNext }) {
  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <span>
        Page {page} of {totalPages} dari {totalData.toLocaleString("id-ID")}
      </span>
      <div>
        <button
          className="btn btn-secondary btn-sm me-2"
          disabled={page === 1}
          onClick={onPrev}
        >
          Previous
        </button>
        <button
          className="btn btn-secondary btn-sm"
          disabled={page === totalPages}
          onClick={onNext}
        >
          Next
        </button>
      </div>
    </div>
  );
}
